/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import LectorBoxExample from '../examples/LectorBox';
import RatingSummaryBoxExample from '../examples/RatingSummaryBox';
import OfferBoxExample from '../examples/OfferBox';
import OfferBoxDiscountExample from '../examples/OfferBoxDiscount';
import StudyPlanBoxExample from '../examples/StudyPlanBox';
import OfferBoxWithGift from '../examples/OfferBoxWithGift';
import OfferBoxCustomContent from '../examples/OfferBoxCustomContent';
import OfferBoxProgramStartStudyExample from '../examples/OfferBoxProgramStartStudy';
import OfferBoxProgramWithProgressExample from '../examples/OfferBoxProgramWithProgress';
import OfferBoxProgramNotAccessibleExample from '../examples/OfferBoxProgramNotAccessible';
import OfferBoxProgramFinishedExample from '../examples/OfferBoxProgramFinished';
const LectorBoxExampleSource = require('!!raw-loader!../examples/LectorBox');
const RatingSummaryBoxExampleSource = require('!!raw-loader!../examples/RatingSummaryBox');
const OfferBoxExampleSource = require('!!raw-loader!../examples/OfferBox');
const OfferBoxDiscountExampleSource = require('!!raw-loader!../examples/OfferBoxDiscount');
const StudyPlanBoxExampleSource = require('!!raw-loader!../examples/StudyPlanBox');
const OfferBoxWithGiftExampleSource = require('!!raw-loader!../examples/OfferBoxWithGift');
const OfferBoxCustomContentExampleSource = require('!!raw-loader!../examples/OfferBoxCustomContent');
const OfferBoxProgramStartStudyExampleSource = require('!!raw-loader!../examples/OfferBoxProgramStartStudy');
const OfferBoxProgramWithProgressExampleSource = require('!!raw-loader!../examples/OfferBoxProgramWithProgress');
const OfferBoxProgramNotAccessibleExampleSource = require('!!raw-loader!../examples/OfferBoxProgramNotAccessible');
const OfferBoxProgramFinishedExampleSource = require('!!raw-loader!../examples/OfferBoxProgramFinished');
export default class BoxesPage extends React.Component {
    render() {
        return (<div>
                <Helmet title="Boxes"/>
                <h3>Offer box for education programs</h3>
                <p>
                    The detail page of the education program has a few use cases of the offer box. The first case has a
                    variant for users without login (another body text) and for another one for B2C. The second case is
                    before the student starts studying. The third case is after the student starts studying. The last
                    one is when the student finished his studies.
                </p>
                <div className="docs-example">
                    <div style={{
                width: '373px',
            }} className="mx-auto mb-6">
                        <OfferBoxProgramNotAccessibleExample />
                    </div>
                    <div style={{
                width: '373px',
            }} className="mx-auto mb-6">
                        <OfferBoxProgramStartStudyExample />
                    </div>
                    <div style={{
                width: '373px',
            }} className="mx-auto mb-6">
                        <OfferBoxProgramWithProgressExample />
                    </div>
                    <div style={{
                width: '373px',
            }} className="mx-auto mb-6">
                        <OfferBoxProgramFinishedExample />
                    </div>
                </div>
                <pre>
                    <PrismCode className="language-jsx">{OfferBoxProgramNotAccessibleExampleSource}</PrismCode>
                </pre>
                <pre>
                    <PrismCode className="language-jsx">{OfferBoxProgramStartStudyExampleSource}</PrismCode>
                </pre>
                <pre>
                    <PrismCode className="language-jsx">{OfferBoxProgramWithProgressExampleSource}</PrismCode>
                </pre>
                <pre>
                    <PrismCode className="language-jsx">{OfferBoxProgramFinishedExampleSource}</PrismCode>
                </pre>
                <h3>Lector box</h3>
                <div className="docs-example">
                    <LectorBoxExample />
                </div>
                <pre>
                    <PrismCode className="language-jsx">{LectorBoxExampleSource}</PrismCode>
                </pre>

                <h3>Rating summary box</h3>
                <div className="docs-example">
                    <RatingSummaryBoxExample />
                </div>
                <pre>
                    <PrismCode className="language-jsx">{RatingSummaryBoxExampleSource}</PrismCode>
                </pre>

                <h3>Offer box</h3>
                <div className="docs-example">
                    <div style={{
                width: '340px',
            }} className="mx-auto mb-6">
                        <OfferBoxExample />
                    </div>
                    <div style={{
                width: '340px',
            }} className="mx-auto mb-6">
                        <OfferBoxDiscountExample />
                    </div>
                    <div style={{
                width: '340px',
            }} className="mx-auto mb-6">
                        <StudyPlanBoxExample />
                    </div>
                    <div style={{
                width: '340px',
            }} className="mx-auto mb-6">
                        <OfferBoxWithGift />
                    </div>
                    <div style={{
                width: '340px',
            }} className="mx-auto">
                        <OfferBoxCustomContent />
                    </div>
                </div>
                <pre>
                    <PrismCode className="language-jsx">{OfferBoxExampleSource}</PrismCode>
                </pre>
                <pre>
                    <PrismCode className="language-jsx">{OfferBoxDiscountExampleSource}</PrismCode>
                </pre>
                <pre>
                    <PrismCode className="language-jsx">{StudyPlanBoxExampleSource}</PrismCode>
                </pre>
                <pre>
                    <PrismCode className="language-jsx">{OfferBoxWithGiftExampleSource}</PrismCode>
                </pre>
                <pre>
                    <PrismCode className="language-jsx">{OfferBoxCustomContentExampleSource}</PrismCode>
                </pre>
            </div>);
    }
}
